<div class="flowchart-container" [ngClass]="getDecisionTreeClass()">
  <ng-container [ngSwitch]="imageKey">
    <img
      *ngSwitchCase="'sellout-novilc-v2'"
      src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-no-vilc-ref-V2.svg"
      alt="SKU Flowchart"
      class="background-image"
    />
    <img
      *ngSwitchCase="'sellout-novilc-v3'"
      src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-no-vilc-ref-V3.png"
      alt="SKU Flowchart"
      class="background-image"
    />
    <object
      *ngSwitchCase="'nosellout-novilc-v2'"
      type="image/svg+xml"
      data="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-no-vilc-ref-V2.svg"
      class="background-image"
    ></object>
    <img
      *ngSwitchCase="'nosellout-novilc-v3'"
      src="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-no-vilc-ref-V3.png"
      alt="SKU Flowchart"
      class="background-image"
    />
    <img
      *ngSwitchCase="'sellout-vilc-v2'"
      src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-with-vilc-ref-V2.png"
      alt="SKU Flowchart"
      class="background-image"
    />
    <img
      *ngSwitchCase="'sellout-vilc-v3'"
      src="assets/images/simulation-decision-trees/decision-tree-simulation-with-sellout-and-with-vilc-ref-V3.png"
      alt="SKU Flowchart"
      class="background-image"
    />
    <img
      *ngSwitchCase="'nosellout-vilc-v2'"
      src="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-with-vilc-ref-V2.png"
      alt="SKU Flowchart"
      class="background-image"
    />
    <img
      *ngSwitchCase="'nosellout-vilc-v3'"
      src="assets/images/simulation-decision-trees/decision-tree-simulation-without-sellout-and-with-vilc-ref-V3.png"
      alt="SKU Flowchart"
      class="background-image"
    />
  </ng-container>

  <div *ngFor="let pos of positions">
    <div
      *ngIf="values?.[pos.key] !== null"
      [class]="
        'overlay ' +
        (pos.type === 'output' ? 'output-text' : 'bold-text') +
        ' ' +
        pos.class
      "
    >
      {{ values[pos.key] }}
    </div>
  </div>

  <img
    *ngIf="!hasSellout"
    src="assets/images/caution-icon.svg"
    alt="Warning"
    [ngClass]="warningIconClass"
    matTooltip="Financial Recovery Test is not applicable in Without Sellout flow"
    matTooltipPosition="below"
  />
</div>

<div *ngIf="values?.overall_decision_tree" class="instruction-box">
  <p>The decision tree above is calculated based on the overall result.</p>
</div>
